<app-input-field
  [label]="placeholder"
  [leftIcon]="searchIcon"
  [rightIcon]="!!searchQuery ? cancelIcon : null"
  [hideLabel]="true"
  fieldId="search_bar_field"
  class="search-bar-field"
  [placeholder]="placeholder"
  [fieldControl]="searchFormControl"
  [trackingScreenName]="trackingScreenName"
  [trackingObject]="trackingObject"
  [trackingAction]="searchTrackingAction"
  [trackingAdditionalProperties]="trackingAdditionalProperties"
  [focusableTrigger$]="focusableTrigger$"
  (onRightActionClick)="clearSearch()"
  (onInputKeyup)="stopKeyupPropagation($event)"
>
</app-input-field>
